import { MSPS_STATES } from '@/utils/consent/constants';

export const isMspsState = (countryCode: string, regionCode?: string) =>
	countryCode === 'US' && (!regionCode || MSPS_STATES.includes(regionCode));
